import New from './New';
import Show from './Show';
import Edit from './Edit';

export default {
  New,
  Show,
  Edit,
};
